<template>
  <div v-click-outside="ocultar">
    <div class="flex flex-col items-center relative">
      <div class="w-full  svelte-1l8159u">
        <label class="text-sm font-medium text-gray-700">{{ label }} <span class="text-red-500">*</span>
          <div class="mt-2 mb-1 p-1 flex border bg-white rounded svelte-1l8159u"
               :class="state===false? 'border-red-500':state===true?'border-green-500':'focus:border-gray-200'">
            <div class="flex flex-auto flex-wrap w-full">
              <div v-for="(row, index) in value" :key="index"
                   class="flex justify-center items-center m-1 font-medium py-1 px-2 bg-white rounded-full text-teal-700 bg-teal-100 border border-teal-300 ">
                <div class="text-xs font-normal leading-none max-w-full flex-initial">{{ row[nameText] }}</div>
                <div class="flex flex-auto flex-row-reverse" @click="deleteItem(index)">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-x cursor-pointer hover:text-teal-400 rounded-full w-4 h-4 ml-2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="flex-1">
                <input @keyup.esc="changeShowDetail" @focus="changeShowDetail" @keyup="isShow"
                       class="bg-transparent p-1 px-2 appearance-none outline-none h-full w-full text-gray-800"
                       :value="text" @input="($event)=>{text=$event.target.value}" ref="mutiple">
              </div>
            </div>
            <div class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-400 svelte-1l8159u">
              <button class="cursor-pointer w-6 h-6 text-gray-600 outline-none focus:outline-none"
                      @click="changeShowDetail">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather feather-chevron-up w-4 h-4">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
              </button>
            </div>
          </div>
          <!--          warning-message-->
          <span class="flex items-center font-medium tracking-wide text-xs mt-1 ml-1"
                :class="state===true?'text-green-500':'text-red-500'"
                v-if="state!==null">
			          {{ state === true ? validMessage : errorMessage }}
		        </span>
        </label>

      </div>
      <!--    detalle-->
      <div v-if="showDetail"
           class="absolute shadow top-100 bg-white z-40 w-full lef-0 rounded max-h-select overflow-y-auto svelte-5uyqqj">
        <div class="flex flex-col w-full">
          <div class="cursor-pointer w-full border-gray-100 rounded-t border-b hover:bg-teal-100"
               v-for="(item, index) in searching" :key="index" @click="select_item(item)"
               :class="indexElementActive===index?'bg-blue-400':''">
            <div
                class="flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative hover:border-teal-100">
              <div class="w-full items-center flex">
                <div class="mx-2 leading-6  ">{{ item[nameText] }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "select_multiple",
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    items: {
      type: Array,
      default: []
    },
    label: {
      type: String,
      default: ""
    },
    nameValue: {
      type: String,
      default: 'value'
    },
    nameText: {
      type: String,
      default: 'text'
    },
    state: {
      default: null
    },
    errorMessage: {
      type: String,
      default: 'No correcto '
    },
    validMessage: {
      type: String,
      default: 'Valido'
    }
  },
  data: () => ({
    showDetail: false,
    text: '',
    selected: [],
    indexElementActive: null,
    lengthElements: null
  }),
  methods: {
    changeShowDetail() {
      this.showDetail = !this.showDetail
    },
    isShow(e) {
      if (e.keyCode === 27) {
        this.showDetail = false
        return null
      } else if (e.keyCode === 40) {
        //down
        this.indexElementActive = this.indexElementActive === null ? 0 : this.indexElementActive + 1
        if (this.indexElementActive >= this.lengthElements) this.indexElementActive = 0
      } else if (e.keyCode === 38) {
        //up
        this.indexElementActive--
        if (this.indexElementActive < 0) this.indexElementActive = this.lengthElements - 1
      } else if (e.keyCode === 13) {
        //  enter
        this.select_item(this.searching[this.indexElementActive])
      } else {
        if (!this.showDetail) this.showDetail = true
      }
    },
    select_item(item) {
      let existe = this.selected.findIndex(element => element[this.nameValue] === item[this.nameValue])
      if (existe >= 0)
        this.selected.splice(existe, 1)
      else
        this.selected.push(item)

      this.$emit('input', this.selected)
      this.text = ''
    },
    deleteItem(index) {
      this.selected.splice(index, 1)
    },
    selectedElemente(element) {
      return this.value.findIndex(row => row[this.nameValue] === element[this.nameValue]) >= 0
    },
    ocultar(e) {
      this.showDetail = false
    }
  },
  computed: {
    searching() {
      let aux = []
      aux = this.items.filter(element => {
        return element[this.nameText].toLowerCase().includes(this.text.toLowerCase()) && !this.selectedElemente(element)
      })
      this.lengthElements = aux.length
      return aux

    }
  },
  watch: {
    value() {
      this.selected=this.value
    }
  },
  mounted() {
    this.selected = this.value
  }
}
</script>

<style scoped>
.top-100 {
  top: 100%
}

.bottom-100 {
  bottom: 100%
}

.max-h-select {
  max-height: 300px;
}
</style>